import React, {useEffect, useState} from 'react'
import {RelacionaObraEndereco} from "./RelacionaObraEndereco";
import globalMU from "../../../globalMU";
import {tratamentoErroPadrao} from "../../use-cases";
import microuniversoApi from "../../api/microuniversoApi";
import {IOrcamento} from "../../types/IOrcamento";
import {useAppSelector} from "../../redux/hooks";
import {Obra} from "../../types/Obra";
import {alterarObra} from "../../use-cases/orcamento/alterarObra";

export const RelacionaObraEnderecoContainer = () => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [obras, setObras] = useState<Obra[]>([])


    const buscaObras = async () => {
        try {
            const dados = (orcamento.CodigoCliente ?? 0) > 7 ? await microuniversoApi.Obra.obterObras(orcamento.CodigoCliente) : []
            setObras(dados)
        }
        catch (e) {
            tratamentoErroPadrao(e)
        } 
    }

    const onChangeObra = async (obra: Obra) => {
        try {
            await alterarObra({obra})
        }
        catch (e) {
            tratamentoErroPadrao(e)
        } 
    }

    useEffect(() => {
        buscaObras()
    }, [])

    return <>
        <RelacionaObraEndereco 
            handleChange={onChangeObra} 
            obras={obras} 
            obraSelecionada={orcamento.IdObra} />
    </>
}
